import React from 'react';
import { Box, Button, Stack, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import useConfig from '../../hooks/useConfig';

const Sidebar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const { config, loading } = useConfig('sidebar');

  const getButtonStyles = (path) => ({
    borderRadius: '4px 0 0 4px',
    justifyContent: 'flex-start',
    paddingLeft: 2,
    paddingRight: 1,
    typography: {
      fontSize: '1.0rem',
      fontWeight: 600,
      textTransform: 'uppercase'
    },
    ...(location.pathname === path && {
      backgroundColor: theme.palette.secondary.dark,
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      }
    })
  });

  const externalLinkStyles = {
    borderRadius: '4px 0 0 4px',
    justifyContent: 'flex-start',
    paddingLeft: 2,
    paddingRight: 1,
    typography: {
      fontSize: '1.0rem',
      fontWeight: 600,
      textTransform: 'uppercase'
    }
  };

  if (loading || !config?.links) {
    return null;
  }

  const sidebarContent = (
    <Stack spacing={1.5} sx={{ pt: 2 }}>
      {config.links.map((link, index) => {
        if (link.type === 'external') {
          return (
            <Button
              key={index}
              variant="contained"
              color="secondary"
              component="a"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              fullWidth
              sx={externalLinkStyles}
            >
              {link.text}
            </Button>
          );
        }
        
        return (
          <Button
            key={index}
            variant="contained"
            color="secondary"
            component={RouterLink}
            to={link.path}
            fullWidth
            sx={getButtonStyles(link.path)}
          >
            {link.text}
          </Button>
        );
      })}
    </Stack>
  );

  return (
    <Box
      sx={{
        position: isMobile ? 'absolute' : 'fixed',
        right: 0,
        top: isMobile ? {
          xs: '56px',
          sm: '64px',
        } : {
          xs: '56px',
          sm: '64px',
        },
        zIndex: 1000,
        width: 220,
      }}
    >
      {sidebarContent}
    </Box>
  );
};

export default Sidebar; 